import { resolveSocialLinks } from '@/lib/socialIcons';

/**
 * @param {object} props
 * @param {import('@/types/cms').SocialLinkItem[]} props.links
 * @param {'icon' | 'pill'} [props.variant]
 * @param {string} [props.className]
 * @param {string} [props.iconClassName]
 */
export default function SocialLinkButtons({
  links,
  variant = 'icon',
  className = '',
  iconClassName = 'w-4 h-4',
}) {
  const items = resolveSocialLinks(links);
  if (!items.length) return null;

  if (variant === 'pill') {
    return (
      <div className={`flex flex-wrap gap-3 ${className}`}>
        {items.map((item) => (
          <a
            key={`${item.icon}-${item.url}`}
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2.5 border border-border text-foreground px-4 py-2.5 rounded-full text-sm font-semibold transition-all duration-200 hover:border-gold hover:text-gold"
          >
            <item.Icon className={iconClassName} />
            <span>{item.label}</span>
          </a>
        ))}
      </div>
    );
  }

  return (
    <div className={`flex gap-3 ${className}`}>
      {items.map((item) => (
        <a
          key={`${item.icon}-${item.url}`}
          href={item.url}
          target="_blank"
          rel="noopener noreferrer"
          title={item.label}
          aria-label={item.label}
          className="w-9 h-9 bg-card border border-border rounded flex items-center justify-center text-muted-foreground hover:text-gold hover:border-gold transition-colors"
        >
          <item.Icon className={iconClassName} />
        </a>
      ))}
    </div>
  );
}
